import { Event } from '../Event'
import { ViewerContext } from '../../constants'
import { ExpertProfileSetupPage } from './types'

export interface ProfileSetupPageSubmittedEventProperties {
  page: ExpertProfileSetupPage
}

export class ProfileSetupPageSubmittedEvent extends Event<
  ProfileSetupPageSubmittedEventProperties
> {
  static displayName = 'Profile Setup Page Submitted'

  static allowedViewerContexts = [ViewerContext.BusinessUser]
}
